import { withTranslation, useTranslation } from 'react-i18next';
import { Box, Container, Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import compose from 'ramda/src/compose';
import RegistrationForm from './components/registrationForm';
import { postMessage } from '../utils/postMessage';
import LocaleKeys from '../locales/keys';
import backArrow from '../images/icon-left.svg';
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.background.default,
    borderRadius: '10px',
    border: `1px solid ${theme.palette.custom.lightBlack}`,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: 0,
    paddingRight: 0,
    maxWidth: '640px',
  },
  hidden: {
    display: 'none',
  },
  link: {
    '&:hover': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  },
  backArrow: {
    float: 'left',
  },
  back: {
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

function Registration(props) {
  const {
    profileType,
    showAlreadyHaveAccountMessage,
    showBackButton,
    leadSource,
    apiUrl,
    securityApiKey,
    securityApiUrl,
    staticApiKey,
    staticApiUrl,
    bypassApigee,
  } = props;

  const classes = useStyles();
  const { t } = useTranslation();

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (isReady) {
      postMessage('module.hideLoader');
    }
  }, [isReady]);

  useEffect(() => {
    if (profileType) {
      postMessage('module.showLoader');
    }
  }, []);

  if (profileType) {
    return (
      <Container
        className={`${classes.container} ${isReady ? '' : classes.hidden}`}
        width={733}
      >
        <Box p={5}>
          <Box>
            {showBackButton ? (
              <Link
                className={classes.link}
                underline="none"
                onClick={() => {
                  postMessage('module.backButton', {});
                }}
              >
                <Typography color="primary" className={classes.backArrow}>
                  <img src={backArrow} alt={t(LocaleKeys.registration.back)} />
                </Typography>

                <Typography
                  color="textPrimary"
                  variant="h6"
                  className={classes.back}
                >
                  {t(LocaleKeys.registration.back)}
                </Typography>
              </Link>
            ) : null}
          </Box>
          <RegistrationForm
            profileType={profileType}
            showAlreadyHaveAccountMessage={showAlreadyHaveAccountMessage}
            leadSource={leadSource}
            apiUrl={apiUrl}
            securityApiKey={securityApiKey}
            securityApiUrl={securityApiUrl}
            staticApiKey={staticApiKey}
            staticApiUrl={staticApiUrl}
            bypassApigee={bypassApigee}
            setIsReady={setIsReady}
          />
        </Box>
      </Container>
    );
  }
  return null;
}

export default compose(withTranslation())(Registration);
